import { searchOutcomesBrowse } from "../../../api/accounts.service";
import { useAccountTypeBrowse } from "../../../hooks/useAccountTypeBrowse";
import { OUTCOME_ACCOUNT_TYPE } from "./outcomes.constants";

export function useOutcomesBrowse() {
  return useAccountTypeBrowse({
    accountType: OUTCOME_ACCOUNT_TYPE,
    searchBrowse: searchOutcomesBrowse,
  });
}
